<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M17.2642 1L10.536 6.00513L11.7873 3.05128L17.2642 1Z"
		fill="#E17726"
		stroke="#E17726"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M1.71619 1L8.40337 6.04615L7.21362 3.05128L1.71619 1Z"
		fill="#E27625"
		stroke="#E27625"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M14.8441 12.5898L13.0389 15.3386L16.8954 16.4052L17.9825 12.6514L14.8441 12.5898Z"
		fill="#E27625"
		stroke="#E27625"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M1.01843 12.6514L2.10561 16.4052L5.94151 15.3386L4.15689 12.5898L1.01843 12.6514Z"
		fill="#E27625"
		stroke="#E27625"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M5.73647 7.95467L4.6698 9.57518L8.46467 9.73928L8.34159 5.63672L5.73647 7.95467Z"
		fill="#E27625"
		stroke="#E27625"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M13.2647 7.95468L10.6186 5.5957L10.5365 9.73929L14.3314 9.57519L13.2647 7.95468Z"
		fill="#E27625"
		stroke="#E27625"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M5.94128 15.3385L8.23872 14.2308L6.24898 12.6719L5.94128 15.3385Z"
		fill="#E27625"
		stroke="#E27625"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M10.762 14.2308L13.0389 15.3385L12.7313 12.6719L10.762 14.2308Z"
		fill="#E27625"
		stroke="#E27625"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M13.038 15.3382L10.7611 14.2305L10.9457 15.7074L10.9252 16.3433L13.038 15.3382Z"
		fill="#D5BFB2"
		stroke="#D5BFB2"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M5.9408 15.3382L8.07413 16.3433L8.05362 15.7074L8.23823 14.2305L5.9408 15.3382Z"
		fill="#D5BFB2"
		stroke="#D5BFB2"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M8.11558 11.6868L6.20789 11.133L7.54122 10.5176L8.11558 11.6868Z"
		fill="#233447"
		stroke="#233447"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M10.8846 11.6868L11.4385 10.5176L12.7923 11.133L10.8846 11.6868Z"
		fill="#233447"
		stroke="#233447"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M5.94172 15.3386L6.26992 12.5898L4.1571 12.6514L5.94172 15.3386Z"
		fill="#CC6228"
		stroke="#CC6228"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M12.7318 12.5898L13.0395 15.3386L14.8446 12.6514L12.7318 12.5898Z"
		fill="#CC6228"
		stroke="#CC6228"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M14.3314 9.57422L10.5365 9.73832L10.8852 11.687L11.4391 10.5178L12.7929 11.1332L14.3314 9.57422Z"
		fill="#CC6228"
		stroke="#CC6228"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M6.20826 11.1332L7.54159 10.5178L8.11595 11.687L8.46467 9.73832L4.6698 9.57422L6.20826 11.1332Z"
		fill="#CC6228"
		stroke="#CC6228"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M4.66931 9.57422L6.2488 12.6717L6.20777 11.1332L4.66931 9.57422Z"
		fill="#E27525"
		stroke="#E27525"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M12.7924 11.1332L12.7308 12.6717L14.3308 9.57422L12.7924 11.1332Z"
		fill="#E27525"
		stroke="#E27525"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M8.46432 9.73828L8.1156 11.687L8.54637 14.0049L8.64894 10.9485L8.46432 9.73828Z"
		fill="#E27525"
		stroke="#E27525"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M10.5361 9.73828L10.3514 10.9485L10.4335 14.0049L10.8848 11.687L10.5361 9.73828Z"
		fill="#E27525"
		stroke="#E27525"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M10.8848 11.6867L10.4335 14.0046L10.7617 14.2302L12.7309 12.6713L12.7924 11.1328L10.8848 11.6867Z"
		fill="#F5841F"
		stroke="#F5841F"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M6.20789 11.1328L6.24891 12.6713L8.23866 14.2302L8.54635 14.0046L8.11558 11.6867L6.20789 11.1328Z"
		fill="#F5841F"
		stroke="#F5841F"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M10.9254 16.343L10.9459 15.7071L10.7613 15.5635H8.21772L8.05362 15.7071L8.07413 16.343L5.9408 15.3379L6.67926 15.9533L8.19721 16.9994H10.7818L12.2998 15.9533L13.0382 15.3379L10.9254 16.343Z"
		fill="#C0AC9D"
		stroke="#C0AC9D"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M10.7618 14.2315L10.4336 14.0059H8.54639L8.23869 14.2315L8.05408 15.7084L8.21818 15.5648H10.7618L10.9464 15.7084L10.7618 14.2315Z"
		fill="#161616"
		stroke="#161616"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M17.5513 6.33333L18.1257 3.5641L17.2642 1L10.7616 5.84103L13.2642 7.95385L16.7924 8.97949L17.5719 8.07692L17.2436 7.83077L17.777 7.33846L17.3667 7.01026L17.9001 6.6L17.5513 6.33333Z"
		fill="#763E1A"
		stroke="#763E1A"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M0.87439 3.5641L1.44875 6.33333L1.07952 6.6L1.61285 7.01026L1.20259 7.33846L1.75644 7.83077L1.40772 8.07692L2.18721 8.97949L5.73593 7.95385L8.23849 5.84103L1.71542 1L0.87439 3.5641Z"
		fill="#763E1A"
		stroke="#763E1A"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M16.7924 8.97877L13.2642 7.95312L14.3308 9.57364L12.7308 12.6711L14.8437 12.6506H17.9821L16.7924 8.97877Z"
		fill="#F5841F"
		stroke="#F5841F"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M5.73589 7.95312L2.18718 8.97877L1.01794 12.6506H4.15641L6.24871 12.6711L4.66923 9.57364L5.73589 7.95312Z"
		fill="#F5841F"
		stroke="#F5841F"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M10.5358 9.73796L10.7615 5.84053L11.7871 3.05078H7.21277L8.23841 5.84053L8.46405 9.73796L8.5461 10.9687V14.0046H10.4333V10.9687L10.5358 9.73796Z"
		fill="#F5841F"
		stroke="#F5841F"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
</svg>

<style>
	svg {
    height: 1.5rem;
    width: 1.5rem
}
</style>
